const SENSITIVE_KEY = /(password|token|api[_-]?key|authorization|secret|reset[_-]?link|private[_-]?key)/i;

export function redactSecrets(value) {
  if (value == null) return value;
  if (Array.isArray(value)) return value.map(redactSecrets);
  if (typeof value === 'object') {
    return Object.fromEntries(
      Object.entries(value).map(([key, item]) => [
        key,
        SENSITIVE_KEY.test(key) ? '[REDACTED]' : redactSecrets(item),
      ]),
    );
  }
  if (typeof value === 'string' && /token=/i.test(value)) {
    return value.replace(/(token=)[^&\s]+/gi, '$1[REDACTED]');
  }
  return value;
}
